import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import InvoiceScanView from '../invoice/invoice-scan-view.js'


class OrderView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		this.dataobject = null;

		this.quote = null;
		this.order = null;
		
		let title = '';
		let description = '';
		let amount = 0;
		let currency = {symbol: ''};
		let currentcard = null;

		
		this.state = {
				title,
				description,
				amount,
				currency,
				registration_text: 'loading...',
				message_text: 'loading...',
				sharelinkmessage: 'loading...',
				sharelink: 'loading...',
				currentcard,
				isQuoteOwner: false,
				isOrderOwner: false,
				buyername: '',
				buyeremail: ''
		}
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('OrderView.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		let sessionuuid = this.props.rootsessionuuid;
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let registration_text = mvcmyquote.t('This order has been registered.');
		
		let message_text = mvcmyquote.t('Buyer details:');
	
		let sharelinkmessage = mvcmyquote.t('Send this link to the vendor to complete this order:');
		
		
		this.setState({registration_text, message_text, sharelinkmessage});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;
		
		if (app_nav_target && (app_nav_target.route == 'order') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;
			var dataobj = params.dataobject;

			if (dataobj && (dataobj.type === 'order') && (dataobj.treated !== true)) {
				this.dataobject = dataobj;

				let order = dataobj;
				this.order = dataobj;

				let txhash = params.txhash;
	
				let amount = order.amount;
				let currencyuuid = order.currencyuuid;

				// time
				let registration_text = mvcmyquote.t('This order has been registered on');

				registration_text += ' ' + mvcmodule.formatDate(order.blocktime, 'YYYY-mm-dd HH:MM:SS') + '.';


				// buyer details
				let buyername_encrypted = order.ownername;
				let buyeremail_encrypted = order.owneremail;
				
				let buyername = mvcmodule.fitString(buyername_encrypted, 12);
				let buyeremail = mvcmodule.fitString(buyeremail_encrypted, 12);
	
				let currency = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {
					console.log('error in OrderView.checkNavigationState: ' + err);
				});
	
				var sharelink =  await this.app.getShareLink(txhash, currency.uuid);

				// original quote
				let quote = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, order.quote);
				this.quote = quote;

				let title = quote.title;
				let description = quote.description;

				// look if a wallet is open
				let currentcard = null;
				let isQuoteOwner = false;
				let isOrderOwner = false;

				let unlocked = await this.app.checkWalletUnlocked()
				.catch(err => {
				});

				if (unlocked) {
					let currentwallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
					
					// is it the quote owner and/or the order own
					currentcard = await this.app.openCurrencyCard(currencyuuid)
					.catch(err => {
						console.log('error in OrderCreateForm.onSubmit: ' + err);
					});

					if (currentcard) {
						let decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, order.owner);

						if (decryptcard) {
							isOrderOwner = true;

							buyername = mvcmyquote.t('You');
							buyeremail = currentwallet.owneremail;					
						}

						decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, quote.owner);
						if (decryptcard) {
							isQuoteOwner = true;

							// we decrypt the buyer's details
							let buyer_rsa_publickey = order.owner_rsa_publickey;
	
							let buyername_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, buyer_rsa_publickey, buyername_encrypted)
							.catch(err => {
								console.log('error in OrderCreateForm.onSubmit: ' + err);
							});
	
							let buyeremail_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, buyer_rsa_publickey, buyeremail_encrypted)
							.catch(err => {
								console.log('error in OrderCreateForm.onSubmit: ' + err);
							});
							
							buyername = (buyername_plain ? buyername_plain : buyername);
							buyeremail = (buyeremail_plain ? buyeremail_plain  : buyeremail);					
	
						}
					}
				}
	
				this.setState({title, description, amount, currency, currentcard, registration_text, isQuoteOwner, isOrderOwner, sharelink, buyername, buyeremail});

				dataobj.viewed = true;
			}

			// mark target as reached
			app_nav_target.reached = true;		
		}
	}
	
	
	// user actions
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		if (this.dataobject) {
			let params = {action: 'create', txhash: this.dataobject.txhash, currencyuuid: this.dataobject.currencyuuid, dataobject: this.dataobject};
			this.app.gotoRoute('invoice', params);
		}
		else
			this.app.alert('Order parameters not found');
		
		return true;
	}

	async onShareLinkClick() {
		const {sharelink} = this.state;
		
		// create a textarea on the fly, then remove it to
		// be able to copy to clipboard
		var textArea = document.createElement("textarea");
		textArea.value = sharelink;

		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand("Copy");
		textArea.remove();

		this.app.alert("Share link has been copied to clipboard");
	}

	
	// rendering
	renderOrderView() {
		let { title, description, amount, currency, registration_text, message_text, sharelinkmessage, sharelink, isQuoteOwner, buyername, buyeremail } = this.state;
		let iswalletlocked = this.props.iswalletlocked;

		return (
			<div className="Form">
				<FormGroup controlId="title">
				<FormLabel>Quote Title</FormLabel>
				<FormControl
					disabled
					autoFocus
					type="text"
					value={title}
					onChange={e => this.setState({title: e.target.value})}
				/>
				</FormGroup>

				<FormGroup controlId="description">
				<FormLabel>Description</FormLabel>
				<FormControl 
					disabled
					as="textarea" 
					rows="3" 
					autoFocus
					type="text"
					value={description}
					onChange={e => this.setState({description: e.target.value})}
				/>
				</FormGroup>

				<FormGroup className="Proposal" controlId="proposal">
				<span className="ProposalCol">
				<FormLabel>Amount</FormLabel>
				<FormControl 
					disabled
					autoFocus
					type="text"
					value={amount}
					onChange={e => this.setState({amount: e.target.value})}
				/>
				</span>
				<span className="ProposalCol">
				<FormLabel>Currency</FormLabel>
				<InputGroup>
					<FormControl 
						disabled
						autoFocus
						type="text"
						value={currency.symbol}
						onChange={e => this.onChangeCurrency(e)}
					/>
				</InputGroup>
				</span>
				</FormGroup>

				<div className="TextBox">
				{registration_text}
				</div>
				
				<div className="TextBox">
				<div>{sharelinkmessage}</div>
					<div className="ShareBlock">
					<span className="ShareLink" onClick={this.onShareLinkClick.bind(this)}>{sharelink}</span>
					<span className="ShareIcon" onClick={this.onShareLinkClick.bind(this)}><FontAwesomeIcon icon={faCopy} /></span>
					</div>
				</div>

				{(isQuoteOwner ?
				<Button onClick={this.onSubmit.bind(this)} type="submit">
					Send Payment Request
				</Button> :
				(iswalletlocked ? <div className="Separator"><span>you are not logged in</span></div> : <hr></hr>)
				)}

				<div className="TextBox">
				{message_text}
				</div>

				<div className="TextBox">
				<div><span>Buyer Name: </span><span>{buyername}</span></div>
				<div><span>Buyer Email: </span><span>{buyeremail}</span></div>
				</div>


				{(this.dataobject ?
				<div>
				<hr></hr>
				<div>
					<InvoiceScanView app={this.app} order={this.dataobject} />
				</div>
				</div> :
				<></>
				)}
			</div>
		  );
	}

	render() {
		return (
			<div className="Container">
				<div className="Title">Order View</div>
				{ this.renderOrderView()}
			</div>
		  );
	}
	
}


// propTypes validation
OrderView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
	iswalletlocked: PropTypes.bool,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		iswalletlocked: state.wallets.islocked,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {OrderView};
export default connect(mapStateToProps, mapDispatchToProps)(OrderView);

